import type { RefObject } from 'react';
import gsap from 'gsap';
// import ScrollTrigger from 'gsap/dist/ScrollTrigger';

export function expandSpacing(
  filterSpacingRef: RefObject<HTMLDivElement | null>,
  expand: boolean,
  callback: () => void,
  immediate: boolean = false,
): void {
  if (filterSpacingRef?.current) {
    gsap.to(filterSpacingRef.current, {
      height: expand ? 'auto' : 0,
      duration: immediate ? 0 : 0.6,
      ease: 'Quad.easeInOut',
      // clearProps: isOpen ? 'height' : '',
      onComplete: () => {
        if (callback) {
          callback();
        }
        // ScrollTrigger.refresh();
      },
    });
  }
}
